import { inject } from '@angular/core';
import { SplashScreenStateService } from '../common/services/splash-screen-state.service';
import { ConfigService } from '../config/services/config.service';
import { Router } from '@angular/router';
import { LoggingService } from '../logging/logging.service';

export const ProgramFeatureGuard = () => {
    const router = inject(Router);
    const splashScreenStateService = inject(SplashScreenStateService);
    const log = inject(LoggingService).getLogger(ProgramFeatureGuard.name);
    const configService = inject(ConfigService);

    if (configService.config()?.configuration.features?.program?.enabled) {
        splashScreenStateService.stop();
        return true;
    } else {
        log.info("Feature program isn't enabled");
        return router.navigate(['/']);
    }
};
